import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4de0f1ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "oxd-main-menu-item-wrapper" }
const _hoisted_2 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_icon = _resolveComponent("oxd-icon")!
  const _component_oxd_text = _resolveComponent("oxd-text")!

  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("a", {
      class: _normalizeClass(_ctx.menuClasses),
      href: _ctx.url
    }, [
      _createVNode(_component_oxd_icon, {
        name: _ctx.icon,
        type: "svg",
        width: "22",
        height: "22",
        class: "oxd-main-menu-item--icon"
      }, null, 8, ["name"]),
      _createVNode(_component_oxd_text, {
        tag: "span",
        class: "oxd-main-menu-item--name"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.name), 1)
        ]),
        _: 1
      })
    ], 10, _hoisted_2)
  ]))
}